import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './AdList.css'; // Estilos personalizados

const apiUrl = process.env.REACT_APP_API_URL || 'https://www.nualily.es';

const AdList = ({ onEdit }) => {
  const [ads, setAds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  /* ---------------------------- Cargar anuncios ---------------------------- */
  useEffect(() => {
    const fetchAds = async () => {
      try {
        const { data } = await axios.get(`${apiUrl}/api/ad`);
        setAds(Array.isArray(data) ? data : []);
      } catch (_) {
        setError('Error al cargar los anuncios. Por favor, intenta de nuevo más tarde.');
      } finally {
        setLoading(false);
      }
    };

    fetchAds();
  }, []);

  /* ---------------------------- Acciones ---------------------------- */
  const handleEdit = (ad) => onEdit(ad);

  const handleDelete = async (adId) => {
    if (!window.confirm('¿Estás seguro de que deseas eliminar este anuncio?')) return;

    try {
      await axios.delete(`${apiUrl}/api/ad/${adId}`);
      setAds((prev) => prev.filter((ad) => ad._id !== adId));
      alert('Anuncio eliminado con éxito');
    } catch (_) {
      alert('Error al eliminar el anuncio. Intenta de nuevo más tarde.');
    }
  };

  /* ---------------------------- Render ---------------------------- */
  if (loading) return <p className="loading">Cargando anuncios...</p>;
  if (error)   return <p className="error">{error}</p>;

  const renderDestino = (ad) => {
    if (ad.productId)    return <span className="ad-destino ad-producto">Producto • {ad.productId}</span>;
    if (ad.externalUrl)  return <span className="ad-destino ad-url">URL • {ad.externalUrl}</span>;
    return                 <span className="ad-destino ad-none">Sin enlace</span>;
  };

  return (
    <div className="ad-list-container">
      <h2>Lista de Anuncios</h2>

      {ads.length === 0 ? (
        <p>No hay anuncios disponibles.</p>
      ) : (
        <ul className="ad-list">
          {ads.map((ad) => (
            <li key={ad._id} className="ad-item">
              {renderDestino(ad)}

              <button className="btn-edit"   onClick={() => handleEdit(ad)}>Editar</button>
              <button className="btn-delete" onClick={() => handleDelete(ad._id)}>Eliminar</button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default AdList;
